import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface TextDocProps {
  titleKey: string;
  paragraphsKey: string;
}
export default function TextDoc({ titleKey, paragraphsKey }: TextDocProps) {
  const { t } = useTranslation();
  const paragraphs = t(paragraphsKey, "", { returnObjects: true });
  return (
    <Stack spacing={2} padding={6} textAlign="left" alignItems="center">
      <Typography variant="h3" textAlign="center" paddingBottom="1em">
        {t(titleKey, "")}
      </Typography>
      {Array.isArray(paragraphs) &&
        paragraphs.map((paragraph: string, idx: number) => (
          <Typography key={idx} width="80%">
            {paragraph}
          </Typography>
        ))}
    </Stack>
  );
}
